import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const AdvisorCard = ({ advisor, isSelected, onSelect }) => {
  return (
    <button
      onClick={() => onSelect(advisor?.id)}
      className={`w-full p-4 rounded-xl border-2 transition-all duration-300 text-left ${
        isSelected
          ? 'border-primary bg-primary/5 shadow-honda-subtle'
          : 'border-border bg-card hover:border-primary/50 hover:shadow-md'
      }`}
    >
      <div className="flex items-center space-x-4">
        <div className="relative flex-shrink-0">
          <Image
            src={advisor?.photo}
            alt={advisor?.photoAlt}
            className="w-16 h-16 md:w-20 md:h-20 rounded-full object-cover"
          />
          {advisor?.available && (
            <div className="absolute bottom-0 right-0 w-4 h-4 bg-success rounded-full border-2 border-card" />
          )}
        </div>

        <div className="flex-1 min-w-0">
          <h4 className="text-base md:text-lg font-heading font-bold text-foreground mb-1">
            {advisor?.name}
          </h4>
          <div className="flex items-center space-x-2 mb-2">
            <div className="flex items-center">
              {[...Array(5)]?.map((_, i) => (
                <Icon
                  key={i}
                  name="Star"
                  size={14}
                  color={i < advisor?.rating ? 'var(--color-warning)' : 'var(--color-muted)'}
                  className={i < advisor?.rating ? 'fill-warning' : 'fill-muted'}
                />
              ))}
            </div>
            <span className="text-sm text-muted-foreground">
              ({advisor?.totalReviews})
            </span>
          </div>
          <p className="text-xs md:text-sm text-muted-foreground line-clamp-1">
            {advisor?.experience} tahun pengalaman
          </p>
          <p className="text-xs text-muted-foreground mt-1">
            {advisor?.specialization}
          </p>
        </div>

        <div
          className={`w-5 h-5 md:w-6 md:h-6 rounded-full border-2 flex items-center justify-center flex-shrink-0 transition-colors ${
            isSelected
              ? 'border-primary bg-primary' :'border-muted-foreground'
          }`}
        >
          {isSelected && <Icon name="Check" size={14} color="white" />}
        </div>
      </div>
    </button>
  );
};

export default AdvisorCard;